<template>
  <div class="logo-container" :class="{ 'auth-logo': isAuthLogo }">
    <img src="@/assets/logo_web.png" class="logo-circle" alt="Top Line Marketing Logo" />
    <div v-if="showText" class="logo-brand-text">Top Line Marketing</div>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
  props: {
    showText: {
      type: Boolean,
      default: false
    },
    isAuthLogo: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
}

.auth-logo {
  flex-direction: column;
  align-items: center;
}

.auth-logo .logo-circle {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}

.auth-logo .logo-brand-text {
  margin-left: 0;
  margin-top: 10px;
}

.logo-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: contain;
}

.logo-brand-text {
  margin-left: 10px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
</style> 